import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import clienteAxios from "../helpers/axios.helper";
import Swal from "sweetalert2";


const CategoriaABM = () => {
  const location = useLocation();
   const navigate = useNavigate();
  const categoriaEnEdicion = location.state?.categoria || null;
  const modoEdicion = location.state?.modoEdicion || false;
  const [tipoCategoria, setTipoCategoria] = useState("categoria1");
  const [nombre, setNombre] = useState("");
  const [categoria1Seleccionada, setCategoria1Seleccionada] = useState("");
  const [categoria2Seleccionada, setCategoria2Seleccionada] = useState("");
  const [categorias1, setCategorias1] = useState([]);
  const [categorias2, setCategorias2] = useState([]);
  
  
  useEffect(() => {
    if (modoEdicion && categoriaEnEdicion) {
      // Determinar el tipo de categoría según las propiedades existentes
      const determinarTipoCategoria = () => {
        if (categoriaEnEdicion.categoria1Nombre && categoriaEnEdicion.categoria2Nombre) {
          return "categoria3";
        } else if (categoriaEnEdicion.categoria1Nombre) {
          return "categoria2";
        }
        return "categoria1";
      };
      setTipoCategoria(determinarTipoCategoria());
      setNombre(categoriaEnEdicion.nombre || "");
      setCategoria1Seleccionada(categoriaEnEdicion.categoria1Id || "");
      setCategoria2Seleccionada(categoriaEnEdicion.categoria2Id || "");
    }
  }, [modoEdicion, categoriaEnEdicion]);
  
  // Función para obtener categorías desde la API usando axios
  const fetchCategorias = async () => {
    try {
      if (tipoCategoria === "categoria1") {
        const response = await clienteAxios.get("/categorias/categoria1");
        setCategorias1(response.data);
      } else if (tipoCategoria === "categoria2" || tipoCategoria === "categoria3") {
        const response = await clienteAxios.get("/categorias/categoria2");
        setCategorias2(response.data);
      }
    } catch (error) {
      Swal.fire('Error', 'No se pudieron obtener las categorías', 'error');  // Alerta de error
    }
  };
  
  useEffect(() => {
    fetchCategorias(); // Llama a la API cuando cambia el tipo de categoría
  }, [tipoCategoria]);
  
  // Función para crear una nueva categoría
  const crearCategoria = async () => {
    try {
      let url = "";
      let payload = {};
      
      // Validación para Categoria 2 (url = /categorias/categoria2)
      if (tipoCategoria === "categoria2" && !categoria1Seleccionada) {
        Swal.fire('Error', 'Debe seleccionar una Categoría 1', 'error'); // Alerta de error
        return; // Detener ejecución si la validación falla
      }
      
      // Validación para Categoria 3 (url = /categorias/categoria3)
      if (tipoCategoria === "categoria3" && !categoria2Seleccionada) {
        Swal.fire('Error', 'Debe seleccionar una Categoría 2', 'error'); // Alerta de error
        return; // Detener ejecución si la validación falla
      }
      
      if (tipoCategoria === "categoria1") {
        url = "/categorias/categoria1";
        payload = { nombre };
      } else if (tipoCategoria === "categoria2") {
        url = "/categorias/categoria2";
        payload = { nombre, categoria1Id: categoria1Seleccionada };
      } else if (tipoCategoria === "categoria3") {
        const categoria2 = categorias2.find(cat => cat.id === parseInt(categoria2Seleccionada));
        if (categoria2) {
          url = "/categorias/categoria3";
          payload = {
            nombre,
            categoria2Id: categoria2Seleccionada,
            categoria1Id: categoria2.categoria1Id,
          };
        } else {
          console.error("No se encontró la categoría 2 seleccionada.");
          return;
        }
      }
      Swal.fire({
        title: "Guardando...",
        text: "Por favor espera mientras se procesa la acción.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Mostrar animación de carga
        },
      });
      const response = await clienteAxios.post(url, payload);
      if (response.status === 200) {
        Swal.close(); // Cerrar el mensaje de carga
        Swal.fire('Éxito', 'Categoría creada con éxito', 'success');  // Alerta de éxito
        fetchCategorias();
        resetFormulario();
        setTimeout(() => {
          navigate('/panel_administracion')
          // Código que se ejecutará después de 1 segundo
        }, 1000);
      } else {
        Swal.close(); // Cerrar el mensaje de carga
        Swal.fire('Error', 'No se pudo crear la categoría', 'error');  // Alerta de error
      }
    } catch (error) {
      Swal.close(); // Cerrar el mensaje de carga
      Swal.fire('Error', 'No se pudo crear la categoría', 'error');  // Alerta de error
    }
  };
  
  
  useEffect(() => {
    fetchCategorias(); // Llamamos a la función para obtener las categorías al cambiar tipoCategoria
  }, [tipoCategoria]);
  
  const editarCategoria = async () => {
    try {
      let url = `/categorias/${tipoCategoria}/${categoriaEnEdicion.id}`;
      let payload = { nombre };
      
      if (tipoCategoria === "categoria2") {
        payload.categoria1Id = parseInt(categoria1Seleccionada);
      } else if (tipoCategoria === "categoria3") {
        payload.categoria1Id = parseInt(categoria1Seleccionada);
        payload.categoria2Id = parseInt(categoria2Seleccionada);
      }
      Swal.fire({
        title: "Guardando...",
        text: "Por favor espera mientras se procesa la acción.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Mostrar animación de carga
        },
      });

      const response = await clienteAxios.put(url, payload);
      if (response.status === 200) {
        Swal.close(); // Cerrar el mensaje de carga
        Swal.fire('Éxito', 'Categoría actualizada con éxito', 'success');  // Alerta de éxito
        resetFormulario();
        setTimeout(() => {
          navigate('/panel_administracion')
          // Código que se ejecutará después de 1 segundo
        }, 1000);
      } else {
        Swal.close(); // Cerrar el mensaje de carga
        Swal.fire('Error', 'No se pudo actualizar la categoría', 'error');  // Alerta de error
      }
    } catch (error) {
      Swal.close(); // Cerrar el mensaje de carga
      Swal.fire('Error', 'No se pudo actualizar la categoría', 'error');  // Alerta de error
    }
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (modoEdicion) {
      editarCategoria();
    } else {
      crearCategoria();
    }
  };
  
  
  const resetFormulario = () => {
    setTipoCategoria("categoria1");
    setNombre("");
    setCategoria1Seleccionada("");
    setCategoria2Seleccionada("");
  };
  
  return (
    <div className="p-6 max-w-4xl mx-auto my-10 bg-white border-2 border-GrisOscuro rounded-md">
    <h1 className="text-2xl font-bold mb-4">Gestión de Categorías</h1>
    
    {/* Formulario dinámico */}
    <form onSubmit={handleSubmit} className="mb-6">
    <div className="mb-4">
    <label className="block text-gray-700 font-medium mb-2">
    Tipo de Categoría
    </label>
    <select
    className="w-full p-2 border rounded-md"
    value={tipoCategoria}
    onChange={(e) => setTipoCategoria(e.target.value)}
    disabled={modoEdicion}
    >
    <option value="categoria1">Categoría 1</option>
    <option value="categoria2">Categoría 2</option>
    <option value="categoria3">Categoría 3</option>
    </select>
    </div>
    
    {/* Inputs dinámicos */}
    {tipoCategoria === "categoria1" && (
      <div className="mb-4">
      <label className="block text-gray-700 font-medium mb-2">Nombre</label>
      <input
      type="text"
      className="w-full p-2 border rounded-md"
      value={nombre}
      onChange={(e) => setNombre(e.target.value)}
      placeholder="Nombre de la Categoría 1"
      required
      />
      </div>
    )}
    
    {tipoCategoria === "categoria2" && (
      <>
      <div className="mb-4">
      <label className="block text-gray-700 font-medium mb-2">
      Categoría 1
      </label>
      <select
      className="w-full p-2 border rounded-md"
      value={categoria1Seleccionada}
      onChange={(e) => setCategoria1Seleccionada(e.target.value)}
      >
      <option value="">Selecciona una Categoría 1</option>
      {categorias1.map((cat) => (
        <option key={cat.id} value={cat.id}>
        {cat.nombre}
        </option>
      ))}
      </select>
      </div>
      <div className="mb-4">
      <label className="block text-gray-700 font-medium mb-2">Nombre</label>
      <input
      type="text"
      className="w-full p-2 border rounded-md"
      value={nombre}
      onChange={(e) => setNombre(e.target.value)}
      placeholder="Nombre de la Categoría 2"
      required
      />
      </div>
      </>
    )}
    
    {tipoCategoria === "categoria3" && (
      <>
      <div className="mb-4">
      <label className="block text-gray-700 font-medium mb-2">
      Categoría 2
      </label>
      <select
      className="w-full p-2 border rounded-md"
      value={categoria2Seleccionada}
      onChange={(e) => {
        setCategoria2Seleccionada(e.target.value);  // Actualiza el estado
      }}
      >
      <option value="">Selecciona una Categoría 2</option>
      {categorias2.map((cat) => (
        <option key={cat.id} value={cat.id}>
        {cat.nombre}
        </option>
      ))}
      </select>
      </div>
      <div className="mb-4">
      <label className="block text-gray-700 font-medium mb-2">Nombre</label>
      <input
      type="text"
      className="w-full p-2 border rounded-md"
      value={nombre}
      onChange={(e) => setNombre(e.target.value)}
      placeholder="Nombre de la Categoría 3"
      required
      />
      </div>
      </>
    )}
    
    <button
    type="submit"
    className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
    >
    {modoEdicion ? "Guardar Cambios" : "Crear Categoría"}
    </button>
    </form>
    </div>
  );
};

export default CategoriaABM;
